import {Injectable} from '@angular/core';

import {NEVER, Observable} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LeavingPageGuardService {
    public isLeaving = false;

    constructor() {}

    canActivate(): Observable<boolean> | boolean {
        if (!this.isLeaving) {
            return true;
        }
        return NEVER;
    }
}
